module.exports = __webpack_public_path__ + "static/media/barrio-chino.17ae4ab8.md";